<script>;
    export let portfimage1;
    export let altimage1;
    export let linkproject1;
    export let textfollowlink1;
    export let description;

</script>
<div class="portfolio move-up wow  animate" style="visibility: visible; opacity: 0;">
    <div class="portfolio portfolio_style--1 mt--30">
        <div class="thumb">
            <img src="{portfimage1}" alt="{altimage1}">
        </div>
        <div class="port-overlay-info">
            <div class="hover-action">
                <h3 class="post-overlay-title"><a href="{linkproject1}">{textfollowlink1}</a></h3>
            </div>
        </div>
    </div>
</div>
{#if description}
    <p class="description">{description}</p>
{/if}


<style>

    .description {
        margin-top: 1em;
        text-align: center;
        padding: 0.5em;
        background-color: white;
        border-radius: 6px;
    }

    *,::after,::before{box-sizing:border-box;}
    h3{margin-top:0;margin-bottom:.5rem;}
    a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects;}
    a:hover{color:#0056b3;text-decoration:underline;border-radius: 24px}
    img{vertical-align:middle;border-style:none;border-radius: 5%}
    h3{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit;}
    h3{font-size:1.75rem;}
    .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
    @media (min-width:576px){
        .container{max-width:540px;}
    }
    @media (min-width:768px){
        .container{max-width:720px;}
    }
    @media (min-width:992px){
        .container{max-width:960px;}
    }
    @media (min-width:1200px){
        .container{max-width:1200px;}
    }
    .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
    .col-12,.col-lg-4,.col-sm-6{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px;}
    .col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
    @media (min-width:576px){
        .col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
    }
    @media (min-width:992px){
        .col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%;}
    }
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        a:not(.btn){text-decoration:underline;}
        img{page-break-inside:avoid;}
        h3{orphans:3;widows:3;}
        h3{page-break-after:avoid;}
        .container{min-width:992px!important;}
    }
    /*! CSS Used from: https://demo.hasthemes.com/brook-preview/style.css */
    @media only screen and (max-width: 575px){
        .container{max-width:450px;}
    }
    @media only screen and (max-width: 479px){
        .container{max-width:320px;}
    }
    *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
    a{color:#ca3c08;text-decoration:none;}
    a:visited{color:#ac0404;}
    a:focus{outline:thin dotted;}
    a:active,a:hover{color:#ea9629;outline:0;}
    a:hover{text-decoration:underline;}
    img{-ms-interpolation-mode:bicubic;border:0;vertical-align:middle;}
    *{-webkit-box-sizing:border-box;box-sizing:border-box;}
    img{max-width:100%;}
    a{-webkit-transition:all 0.4s ease-in-out 0s;-o-transition:all 0.4s ease-in-out 0s;transition:all 0.4s ease-in-out 0s;}
    h3{margin:0;margin-bottom:15px;}
    h3{font-family:"louis_george_caferegular";line-height:1.3;color:#222222;}
    h3{font-size:26px;}
    @media only screen and (min-width: 768px) and (max-width: 991px){
        h3{font-size:24px;}
    }
    @media only screen and (max-width: 767px){
        h3{font-size:24px;}
    }
    h3{font-weight:700;}
    a:hover,a:focus,a:active{text-decoration:none;outline:none;}
    a:visited{color:inherit;}
    .move-up{-webkit-transform:translateY(0px);-ms-transform:translateY(0px);transform:translateY(0px);}
    .move-up.animate{-webkit-transform:translateY(100px);-ms-transform:translateY(100px);transform:translateY(100px);-webkit-animation:moveVertical .65s ease forwards;animation:moveVertical .65s ease forwards;}
    .bg_color--1{background:#fff;}
    .mt--30{margin-top:30px;}
    .ptb--100{padding:100px 0;}
    @media only screen and (min-width: 768px) and (max-width: 991px){
        .ptb-md--80{padding:80px 0;}
    }
    @media only screen and (max-width: 767px){
        .ptb-sm--60{padding:60px 0;}
    }
    a{-webkit-transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);-o-transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);color:#fff;}
    a:hover{color:rgba(255, 255, 255, 0.5);}
    .portfolio{position:relative;}
    .portfolio.portfolio_style--1 .thumb img{width:100%;}
    .portfolio.portfolio_style--1 .port-overlay-info{position:absolute;top:0;transform: scale(1.1);left:0;visibility:hidden;width:100%;height:100%;opacity:0;-webkit-transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);-o-transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);background-color: #6180fc;}
    .portfolio.portfolio_style--1 .port-overlay-info .hover-action{text-align:center;padding:0 15px;top:50%;position:absolute;width:100%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}
    .portfolio.portfolio_style--1 .port-overlay-info .hover-action h3.post-overlay-title{opacity:0;-webkit-transition:.3s ease-out 0s;-o-transition:.3s ease-out 0s;transition:.3s ease-out 0s;-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);font-size:18px;line-height:1.4;color:#fff;margin:0;font-weight:600;letter-spacing:0em;font-family:"Poppins", sans-serif;}
    @media only screen and (max-width: 767px){
        .portfolio.portfolio_style--1 .port-overlay-info .hover-action h3.post-overlay-title{font-size:20px;}
    }
    .portfolio.portfolio_style--1 .port-overlay-info .hover-action h3.post-overlay-title a{color:#fff;}
    .portfolio.portfolio_style--1:hover .port-overlay-info{visibility:visible;opacity:.9;transform: scale(1); border-radius: 24px}
    .portfolio.portfolio_style--1:hover .port-overlay-info h3.post-overlay-title{opacity:1;-webkit-transition:.5s ease-out .2s;-o-transition:.5s ease-out .2s;transition:.5s ease-out .2s;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}
    a{color:#267481;text-decoration:none;}
    body.template-color-1 .portfolio.portfolio_style--1 .port-overlay-info{background-color:#0038E3;}
    body.template-font-1 h3{font-family:"Poppins", sans-serif;}
    /*! CSS Used keyframes */
    @-webkit-keyframes moveVertical{to{opacity:1;-webkit-transform:translateY(0);}}
    @keyframes moveVertical{to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0);}}
    /*! CSS Used fontfaces */
*,::after,::before{box-sizing:border-box;}
    h2,h6{margin-top:0;margin-bottom:.5rem;}
    p{margin-top:0;margin-bottom:1rem;}
    h2,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit;}
    h2{font-size:2rem;}
    h6{font-size:1rem;}
    .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
    .col-lg-8,.col-md-10{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px;}
    @media (min-width:768px){
        .col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%;}
    }
    @media (min-width:992px){
        .col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%;}
    }
    .justify-content-center{-ms-flex-pack:center!important;justify-content:center!important;}
    .text-center{text-align:center!important;}
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        h2,p{orphans:3;widows:3;}
        h2{page-break-after:avoid;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/style.css */
    .font-alt{font-family:'Nunito', sans-serif;}
    .dark-color{color:#222;}
    .section-title h6{margin:0 0 15px;font-weight:700;font-size:15px;}
    .section-title h2{font-size:35px;font-weight:700;margin:0 0 25px;}
    .section-title p{font-size:15px;margin:0;}
    @media (max-width: 991px){
        .section-title h2{font-size:35px;}
    }
    @media (max-width: 767px){
        .section-title h2{font-size:28px;margin:0 0 20px;}
    }
    .m-60px-b{margin-bottom:60px;}
    @media (max-width: 767px){
        .sm-m-40px-b{margin-bottom:40px;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/color/default.css */
    ::selection{background-color:#0575E6;color:#fff;}
    ::-moz-selection{background-color:#0575E6;color:#fff;}
    .theme-color{color:#0575E6;}
    /*! CSS Used fontfaces */
</style>